// State module for dashboard information

import cubejsGraphApi from '@/services/api/internal/cubejsGraph.api';
import SimpleDataModule from '@/store/simpleDataModule';

const SelectedRequests = new SimpleDataModule([], { resultSet: null });

SelectedRequests.actions = {
  setParams({ commit, getters }, params) {
    commit('SET_PARAMS', { ...getters.params, ...params });
  },
  load({ commit }, resultSet) {
    commit('SET_LOADING');
    cubejsGraphApi
      .load(
        resultSet.drillDown({
          yValues: ['requests.count'],
        })
      )
      .then((res: any) => {
        commit('SET_DATA', res.loadResponse.results[0].data);
      })
      .catch((err) => {
        commit('SET_ERROR', err);
      });
  },
};

export default SelectedRequests;
